import { IconCircleCheck } from './IconCircleCheck'

export default IconCircleCheck
